module.exports = __webpack_public_path__ + "img/blshj02_center_002.addce5e7.png";